<template>
    <div class="animated fadeIn">
        <section class="section">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content is-mobile">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center">
                            {{ $t('poc:poc.secure_title') }}
                        </h3>
                    </div>
                </div>
                <div class="columns is-centered">
                    <div class="column content" style="flex: inherit">
                        <figure class="image featured-in-img" v-if="!isMobile()">
                            <img alt="Control panel section" src="./assets/security-section.svg" width="600" height="600">
                        </figure>
                        <figure class="image featured-in-img-mobile mobile-screen" v-else>
                            <img alt="Control panel section" src="./assets/security-section.svg" width="300" height="300">
                        </figure>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container">
                        <p class="is-size- small-container uptin-text-7 uptin-text-center">
                            {{ $t('poc:poc.secure_description') }}
                        </p>
                    </div>
                </div>

            </div>
        </section>
    </div>
</template>

<style lang="scss">
</style>

<script>
export default {
    components: {
    },
    name: 'security',
    methods: {
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        }
    }
}
</script>
